import { Link } from "react-router-dom";

const Home = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <section className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-sky-800 px-4 py-16 text-white">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl space-y-6">
          <p className="text-sm uppercase tracking-[0.4em] text-sky-300">Welcome to Tenzies</p>
          <h1 className="text-5xl font-extrabold leading-tight sm:text-6xl">
            Roll, hold, and win the classic dice challenge.
          </h1>
          <p className="text-lg text-slate-200 sm:text-xl">
            Play faster rounds, lock dice, and track your best scores. Tenzies is easy to learn and hard to stop playing.
          </p>

          <div className="flex flex-col gap-4 sm:flex-row">
            <Link
              to="Game"
              className="inline-flex items-center justify-center rounded-full bg-sky-400 px-8 py-4 text-base font-semibold text-slate-950 transition hover:bg-sky-300"
            >
              Play Now
            </Link>
            <Link
              to="Sign-In"
              className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-slate-900/80 px-8 py-4 text-base font-semibold text-white transition hover:bg-slate-800"
            >
              Sign In
            </Link>
          </div>

          {user && (
            <div className="rounded-3xl border border-white/10 bg-white/10 p-5 text-slate-100 shadow-xl shadow-slate-950/20">
              <p className="text-sm uppercase tracking-[0.2em] text-sky-200">Hello, {user.name}</p>
              <p className="mt-2 text-base text-slate-200">
                Continue your game and try to beat your best roll count.
              </p>
            </div>
          )}
        </div>

        <div className="relative mx-auto w-full max-w-xl overflow-hidden rounded-[2rem] border border-white/10 bg-slate-900/80 p-6 shadow-2xl shadow-slate-950/30">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.35),_transparent_42%)]" />
          <div className="relative space-y-6">
            <div className="grid grid-cols-5 gap-4 text-center text-white">
              {[...Array(10)].map((_, idx) => (
                <div key={idx} className="rounded-3xl bg-slate-800/90 px-4 py-6 shadow-inner shadow-slate-950/20">
                  <span className="block text-2xl font-bold">{idx % 6 + 1}</span>
                </div>
              ))}
            </div>

            <div className="rounded-3xl bg-slate-950/90 p-6 text-slate-200">
              <h2 className="text-2xl font-semibold">How it works</h2>
              <ul className="mt-4 space-y-3 text-sm leading-6 text-slate-300">
                <li>• Roll the dice until all 10 numbers match.</li>
                <li>• Click a die to freeze it before the next roll.</li>
                <li>• Track time and roll count for your best performance.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
